import { observer } from 'mobx-react'
import React from 'react'

import { SEARCHED_LOCATION_MARKER_INDEX } from '../../constants'
import { useMapsInstanceContext } from '../../hooks/useMapsInstanceContext'
import { MapCoordinates } from '../../types'
import MapMarker from '../MapMarker/MapMarker'
import SearchedLocationMarkerPopup from '../SearchedLocationMarkerPopup/SearchedLocationMarkerPopup'

interface Props {
   isReadOnly: boolean
   searchedLocation: MapCoordinates | null
   selectedMarkerIndex: number | null
   setSelectedMarkerIndex: (index: number | null) => void
   setSearchedLocation: (coordinates: MapCoordinates | null) => void
   onAddCoordinates: (clickedCoordinates: MapCoordinates) => void
}

const SearchedLocationMarker = (props: Props): React.ReactElement => {
   const {
      searchedLocation,
      selectedMarkerIndex,
      setSelectedMarkerIndex,
      setSearchedLocation,
      onAddCoordinates
   } = props

   const { setIsEditMode } = useMapsInstanceContext()

   const handleOnMarkerClick = () => {
      const isActiveMarker =
         selectedMarkerIndex === SEARCHED_LOCATION_MARKER_INDEX

      if (isActiveMarker) setSelectedMarkerIndex(null)
      else setSelectedMarkerIndex(SEARCHED_LOCATION_MARKER_INDEX)
   }

   const onAddSearchedLocation = (coordinates: MapCoordinates): void => {
      setIsEditMode(true)
      onAddCoordinates(coordinates)

      setSearchedLocation(null)
      setSelectedMarkerIndex(null)
   }

   return (
      <React.Fragment>
         {searchedLocation ? (
            <React.Fragment>
               <MapMarker
                  coordinates={searchedLocation}
                  isDraggable={false}
                  markerNumber={SEARCHED_LOCATION_MARKER_INDEX}
                  shouldShowMarkerNumber={false}
                  onMove={() => null}
                  onClick={() => handleOnMarkerClick()}
               />

               {selectedMarkerIndex === -1 && (
                  <SearchedLocationMarkerPopup
                     isReadOnly={props.isReadOnly}
                     searchedLocation={searchedLocation}
                     onAddCoordinates={onAddSearchedLocation}
                  />
               )}
            </React.Fragment>
         ) : null}
      </React.Fragment>
   )
}

export default observer(SearchedLocationMarker)
